import script from "./PrivacyPolicyPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivacyPolicyPage.vue?vue&type=script&setup=true&lang=js"

import "./PrivacyPolicyPage.vue?vue&type=style&index=0&id=28e6f642&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/claims-portal/claims-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28e6f642"]])

export default __exports__